import React, { Component } from 'react';
import radium from 'radium';

import home from '../../static/images/Block4/home.png';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: 50,
    '@media (max-width: 1024px)': {
      alignItems: 'center',
      flexDirection: 'column-reverse',
    },
  },
  leftWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 20px',
  },
  socialFunctionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px 0',
  },
  socialFunctionBlock: {
    width: 170,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    backgroundColor: '#EE8356',
    position: 'relative',
    borderRadius: 20,
    color: 'white',
    fontWeight: 600,
    letterSpacing: 3,
    textDecoration: 'none',
  },
  socialText: {
  },
  home: {
    width: 25,
    height: 25,
  },
  triangle: {
    width: 25,
    borderTop: '7px solid transparent',
    borderBottom: '7px solid transparent',
    borderLeft: '11px solid white',
  },
  socialNumber: {
    color: 'rgb(143, 88, 39)',
    margin: '10px 0',
    letterSpacing: 1,
  },
  rightWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 20px',
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    lineHeight: '7px',
    color: '#8F5827',
    letterSpacing: 2,
    textAlign: 'center',
    '@media (max-width: 670px)': {
      lineHeight: 1,
    },
    '@media (max-width: 1024px)': {
      alignItems: 'center',
    },
  },
  paragraphBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: 10,
    '@media (max-width: 1024px)': {
      alignItems: 'center',
    },
  },
  specialParagraphBlock: {
    display: 'flex',
    '@media (max-width: 414px)': {
      flexDirection: 'column',
    },
  },
};

class SocialBlock extends Component {
  render() {
    const {
      comments,
      likes,
      shares,
    } = this.props;

    return (
      <div style={styles.wrapper}>
        <div style={styles.leftWrapper}>
          <div style={styles.socialFunctionWrapper}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/556055591230516/posts/1064278483741555/" style={styles.socialFunctionBlock}>
              <img style={styles.home} src={home} alt="房子" />
              按個讚
              <div style={styles.triangle} />
            </a>
            <p style={styles.socialNumber}>
              已有 {likes} 讚
            </p>
          </div>
          <div style={styles.socialFunctionWrapper}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/556055591230516/posts/1064278483741555/" style={styles.socialFunctionBlock}>
              <img style={styles.home} src={home} alt="房子" />
              分享吧
              <div style={styles.triangle} />
            </a>
            <p style={styles.socialNumber}>
              已有 {shares} 分享
            </p>
          </div>
          <div style={styles.socialFunctionWrapper}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/556055591230516/posts/1064278483741555/" style={styles.socialFunctionBlock}>
              <img style={styles.home} src={home} alt="房子" />
              <span style={styles.socialText}>
                留言去
              </span>
              <div style={styles.triangle} />
            </a>
            <p style={styles.socialNumber}>
              已有 {comments} 留言
            </p>
          </div>
        </div>
        <div style={styles.rightWrapper}>
          <div style={styles.descriptionWrapper}>
            <div style={styles.paragraphBlock}>
              <p>
                如果你和我們一樣
              </p>
              <p>
                為倆位小球員的熱血揮擊所震撼
              </p>
              <p>
                為如兄如弟的牽絆所感動
              </p>
              <p>
                如果你和我們一樣
              </p>
              <p>
                不僅關心他們的現在
              </p>
              <div style={styles.specialParagraphBlock}>
                <p>
                  更願意成為他們
                </p>
                <p>
                  未來一路成長的陪伴力量
                </p>
              </div>
            </div>
            <div style={styles.paragraphBlock}>
              <p>
                請一起加入
              </p>
              <div style={styles.specialParagraphBlock}>
                <p>
                  Home Run Taiwan FB 粉絲團
                </p>
                <p>
                  「百校贈球計畫」
                </p>
              </div>
              <p>
                共同成為這群棒球小將的夢想推手
              </p>
              <p>
                只要為《倆好球》影片
              </p>
              <p>
                按一個讚、一則留言、一次分享
              </p>
              <p>
                都能化作真實的支持
              </p>
            </div>
            <div style={styles.paragraphBlock}>
              <p>
                我們將把 5000 顆球
              </p>
              <p>
                送至 100 所小學少棒隊
              </p>
              <p>
                每累積 1000 次按讚、留言、分享
              </p>
              <p>
                就能多一所學校拿到國際賽事指定用球
              </p>
            </div>
            <div style={styles.paragraphBlock}>
              <p>
                讓他們一次一次苦練揮棒
              </p>
              <p>
                與撲接的努力果實
              </p>
              <p>
                不只是比賽中的一次得分
              </p>
              <div style={styles.specialParagraphBlock}>
                <p>
                  更可以是成為未來人生的一支
                </p>
                <p>
                  HOME RUN
                </p>
              </div>
            </div>
            <div style={styles.paragraphBlock}>
              <p>
                這份力量將從你開始
              </p>
              <p>
                一起用愛讓孩子們的夢想前進
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default radium(SocialBlock);
